import lswRequest from './lsw-request.json';

export default lswRequest;
